$(".address-form input").on("input", function () {
    if ($(this)[0].checkValidity()) {
        $(".save-address").removeClass("disabled");
        $(this)
            .parents(".form-group")
            .find(".pattern-error")
            .addClass("d-none");
    } else {
        $(".save-address").addClass("disabled");
    }
});

$(".input-pattern").change(function () {
    if (!$(this)[0].checkValidity()) {
        $(this)
            .parents(".form-group")
            .find(".pattern-error")
            .removeClass("d-none");
    }
});

$(".input-pattern-red").change(function () {
    if (!$(this)[0].checkValidity()) {
        $(this)
            .parents(".form-group")
            .find(".lux-disclaimer .text-luxplus")
            .removeClass("text-luxplus");
    }
});

function containsUppercase(str) {
    const uppercasePattern = /\p{Lu}/u;
    return uppercasePattern.test(str);
}

function containsLowercase(str) {
    const lowercasePattern = /\p{Ll}/u;
    return lowercasePattern.test(str);
}

function containsNumber(str) {
    return /[0-9]/.test(str);
}

$(".password-check-validity").on("input", function () {
    const inputValue = $(this)[0].value;

    if (inputValue.length >= 8) {
        $(".password-length").addClass("accepted");
    } else {
        $(".password-length").removeClass("accepted");
    }

    if (containsUppercase(inputValue)) {
        $(".password-uppercase").addClass("accepted");
    } else {
        $(".password-uppercase").removeClass("accepted");
    }

    if (containsLowercase(inputValue)) {
        $(".password-lowercase").addClass("accepted");
    } else {
        $(".password-lowercase").removeClass("accepted");
    }

    if (containsNumber(inputValue)) {
        $(".password-number").addClass("accepted");
    } else {
        $(".password-number").removeClass("accepted");
    }
});

const validation = {
    showPassword(e) {
        var passwordInput = e
            .closest(".lux-password-wrapper")
            .querySelector("input");

        if (passwordInput.getAttribute("type") === "password") {
            passwordInput.setAttribute("type", "text");
            e.classList.add("active");
        } else {
            passwordInput.setAttribute("type", "password");
            e.classList.remove("active");
        }
    },
    checkPattern(input) {
        const saveAddress = document.querySelector(".save-address");

        if (input.checkValidity()) {
            saveAddress.classList.remove("disabled");
            saveAddress.removeAttribute("disabled");

            const patternError = input
                .closest(".form-group")
                ?.querySelector(".pattern-error");
            if (patternError) {
                patternError.classList.add("d-none");
            }
        } else {
            saveAddress.classList.add("disabled");
            saveAddress.setAttribute("disabled");
        }
    },
};
window.validation = validation;

document.querySelectorAll(".address-form").forEach(function (form) {
    const saveAddress = form.querySelector(".save-address");

    if (saveAddress) {
        saveAddress.addEventListener("click", function () {
            const inputs = form.querySelectorAll(
                "input[pattern], input[required]",
            );

            inputs.forEach((input) => {
                const errorContainer = input
                    .closest(".form-group")
                    ?.querySelector(".pattern-error");

                if (!input.checkValidity()) {
                    input.classList.add("is-invalid");
                    if (errorContainer) {
                        errorContainer.classList.remove("d-none");
                    }
                } else {
                    input.classList.remove("is-invalid");
                    if (errorContainer) {
                        errorContainer.classList.add("d-none");
                    }
                }
            });
        });
    }
});

if (import.meta.hot) {
    import.meta.hot.accept();
}
